"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPoint = exports.poleMeasurementAccuracyTypes = exports.TopologicalEditorPointCSS = void 0;
var theme_1 = require("../../../components/theme");
var theme_palette_1 = require("../../../components/theme.palette");
var dom_1 = require("../../../dom");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var classnames_1 = require("../../../util/classnames");
var CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 1.5;
var CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';
var CIRCLE_BORDER_SIZE = 2;
var CIRCLE_DOT_SIZE = 3;
var MAX_TITLE_WIDTH = 120;
exports.TopologicalEditorPointCSS = {
    container: 'c-TopologicalEditorMapPoint',
    titleContainer: 'c-TopologicalEditorMapPoint__titleContainer',
    title: 'c-TopologicalEditorMapPoint__title',
    isSelected: 'c-TopologicalEditorMapPoint--isSelected',
    locationFixed: 'c-TopologicalEditorMapPoint--fixed',
    locationEdited: 'c-TopologicalEditorMapPoint--edited',
    locationManualOrFloat: 'c-TopologicalEditorMapPoint--manualOrFloat',
    locationLow: 'c-TopologicalEditorMapPoint--low',
    locationDefault: 'c-TopologicalEditorMapPoint--default'
};
var PointStyles = (_a = {},
    _a[exports.TopologicalEditorPointCSS.titleContainer] = {
        position: 'absolute',
        width: "".concat(MAX_TITLE_WIDTH, "px"),
        'justify-content': 'center'
    },
    _a[exports.TopologicalEditorPointCSS.title] = {
        background: "".concat((0, theme_1.rgba)(theme_palette_1.ColorPaletteBlue.C900, 0.5)),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: "".concat((0, theme_1.rgba)(theme_palette_1.WHITE)),
        padding: '4px',
        'z-index': '500'
    },
    _a[exports.TopologicalEditorPointCSS.container] = {
        height: CIRCLE_SIZE_PX,
        width: CIRCLE_SIZE_PX,
        minWidth: CIRCLE_SIZE_PX,
        maxWidth: CIRCLE_SIZE_PX,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        background: theme_1.DefaultTheme.color.accent,
        border: "".concat(CIRCLE_BORDER_SIZE, "px solid ").concat((0, theme_1.rgba)(theme_palette_1.BLACK, 0.5)),
        cursor: 'pointer',
        transition: ['box-shadow'],
        transitionDuration: 150
    },
    _a["".concat(exports.TopologicalEditorPointCSS.container, ".").concat(exports.TopologicalEditorPointCSS.isSelected)] = {
        boxShadow: "0 0 0 3px rgba(".concat(theme_palette_1.ColorPaletteBlue.C700, ", 0.24), 0 0 0 3px rgba(").concat(theme_palette_1.ColorPaletteBlue.C700, ", 0.64)"),
        border: "".concat(CIRCLE_BORDER_SIZE, "px solid rgba(255, 255, 255, 0.87)")
    },
    _a["".concat(exports.TopologicalEditorPointCSS.container, ":hover, ").concat(exports.TopologicalEditorPointCSS.container, ".").concat(exports.TopologicalEditorPointCSS.isSelected, ":hover")] = {
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2w5
    },
    _a[exports.TopologicalEditorPointCSS.locationFixed] = {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteGreen.A700)
    },
    _a["".concat(exports.TopologicalEditorPointCSS.locationEdited)] = (_b = {
            backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteGreen.A700)
        },
        _b['&::after'] = {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: "".concat(CIRCLE_DOT_SIZE, "px"),
            height: "".concat(CIRCLE_DOT_SIZE, "px"),
            borderRadius: '50%',
            backgroundColor: (0, theme_1.rgba)(theme_palette_1.BLACK)
        },
        _b),
    _a[exports.TopologicalEditorPointCSS.locationManualOrFloat] = {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteYellow.C400)
    },
    _a[exports.TopologicalEditorPointCSS.locationLow] = {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteRed.A700)
    },
    _a[exports.TopologicalEditorPointCSS.locationDefault] = {
        backgroundColor: theme_1.DefaultTheme.color.accent
    },
    _a);
(0, theme_1.addStyles)(PointStyles);
exports.poleMeasurementAccuracyTypes = {
    rtk_fixed: exports.TopologicalEditorPointCSS.locationFixed,
    edited: exports.TopologicalEditorPointCSS.locationEdited,
    manual: exports.TopologicalEditorPointCSS.locationManualOrFloat,
    rtk_float: exports.TopologicalEditorPointCSS.locationManualOrFloat,
    low: exports.TopologicalEditorPointCSS.locationLow,
    default: exports.TopologicalEditorPointCSS.locationDefault
};
exports.MapPoint = {
    view: function (_a) {
        var _b, _c;
        var summary = _a.summary, point = _a.point, isCollectionSelected = _a.isCollectionSelected, poleAccuracy = _a.poleAccuracy, onClick = _a.onClick, onCollectionMouseOver = _a.onCollectionMouseOver, onCollectionMouseOut = _a.onCollectionMouseOut, showCollectionTitle = _a.showCollectionTitle, showTitlesOnMap = _a.showTitlesOnMap;
        return [
            (0, mithril_1.m)('div', (_b = {
                    key: summary.objectId
                },
                _b[dom_1.DRAGON_ID] = summary.revision,
                _b[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.COLLECTION,
                _b.className = (0, classnames_1.classNames)(exports.TopologicalEditorPointCSS.container, exports.poleMeasurementAccuracyTypes[poleAccuracy], (_c = {},
                    _c[exports.TopologicalEditorPointCSS.isSelected] = isCollectionSelected,
                    _c)),
                _b.onclick = onClick,
                _b.style = {
                    top: (point.y - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE) + 'px',
                    left: (point.x - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE) + 'px'
                },
                _b.onmouseover = onCollectionMouseOver,
                _b.onmouseout = onCollectionMouseOut,
                _b)),
            (0, mithril_1.m)('div', {
                className: exports.TopologicalEditorPointCSS.titleContainer,
                style: {
                    top: (point.y - (theme_1.DefaultTheme.spacingFactor * 9)) + 'px',
                    left: (point.x - (MAX_TITLE_WIDTH / 2)) + 'px',
                    display: showCollectionTitle || showTitlesOnMap ? 'flex' : 'none'
                }
            }, (0, mithril_1.m)('div', {
                className: exports.TopologicalEditorPointCSS.title
            }, summary.title || summary.subtitle || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE)))
        ];
    }
};
//# sourceMappingURL=map.point.js.map